var data = {
  "width": 512,
  "height": 512,
  "body": "<path fill=\"currentColor\" d=\"M80 96h352v32H80zm0 144h352v32H80zm0 144h352v32H80z\"/>"
};
exports.__esModule = true;
exports.default = data;